/**
 * Format helpers for lead ops timeline display.
 */

const SKIP_REASON_LABELS = {
  no_os_public_base_url: "OS public base URL not configured",
  no_inventory_lines: "No inventory lines on the lead",
  schedule_failed: "Scheduling failed",
};

/**
 * @param {string} [reason]
 * @returns {string}
 */
export function formatPipelineSkipReason(reason) {
  if (!reason) {
    return "Unknown reason";
  }
  return SKIP_REASON_LABELS[reason] || reason.replace(/_/g, " ");
}

/**
 * @param {object|null|undefined} detail
 * @returns {string[]}
 */
export function formatOpsEventDetailLines(detail) {
  if (!detail || typeof detail !== "object") {
    return [];
  }

  const lines = [];

  if (detail.reason) {
    lines.push(`Reason: ${formatPipelineSkipReason(detail.reason)}`);
  }
  if (detail.error) {
    lines.push(`Error: ${detail.error}`);
  }
  if (detail.provider && detail.mode) {
    lines.push(`Mode: ${detail.mode}`);
  }
  if (detail.quoteId) {
    lines.push(`Quote: ${detail.quoteId}`);
  }
  if (detail.reviewState) {
    lines.push(`Review: ${detail.reviewState.replace(/_/g, " ")}`);
  }
  if (detail.total != null && detail.total !== "") {
    lines.push(`Total: R${Number(detail.total).toLocaleString("en-ZA")}`);
  }
  if (detail.expectedM3 != null) {
    lines.push(`Volume: ${detail.expectedM3} m³`);
  }
  if (detail.confidence) {
    lines.push(`Confidence: ${detail.confidence}`);
  }
  if (detail.referenceNumber) {
    lines.push(`Reference: ${detail.referenceNumber}`);
  }
  if (detail.itemCount != null) {
    lines.push(`Items: ${detail.itemCount}`);
  }
  if (detail.to) {
    lines.push(`Email: ${detail.to}`);
  }
  if (detail.inventoryLineCount != null) {
    lines.push(`Inventory lines: ${detail.inventoryLineCount}`);
  }

  return lines;
}

/**
 * @param {string} [provider]
 * @returns {string|null}
 */
export function formatEnrichmentProviderLabel(provider) {
  if (!provider) {
    return null;
  }
  if (provider === "fixture") {
    return "Mock (fixture)";
  }
  return provider;
}
